import React, {useMemo, useRef} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {FormattedMessage} from "react-intl";

import AddIcon from '@mui/icons-material/Add';
import IconButton from "@mui/material/IconButton";

import FeatureName from "../../../../visComponents/featureName";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import LookFeaturePrice from "./lookFeaturePrice";
import FeatureThumbnail from "../../../../visComponents/featureThumbnail";
// import LookListFeatureActions from "./lookListFeatureActions";
import {
  setLookActiveCategory,
  setLookActiveFeature, setLookAllWallsTutorial,
  setLookCompatabilityAlert,
  setLookDemoPointsClicked,
  setLookOverlayOpened,
  // setLookAllWallsOpened
} from "../../../../../actions/lookFunctions";
import Config from "../../../../../config";
import {getCommonCoords, getFeatureCoords, getLayerCenter, navFeatureCLick} from "../../lookFunctions";
import LookListFeatureCheckmark from "./lookListFeatureCheckmark";
import {addToCart, setCanvasScale, updateCanvasCount} from "../../../../../actions/actionFunctions";
import LookCanvasContext from "../../../lookCanvasContext";
import {getCurrentLayout} from "../../../../appLayout";
import {LOOK_WALLS_ONLY} from "../../../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {getCartItemObject, getFeatureIsLocked} from "../../../../../misc/helpers";
import {
  enableRelatedFeature,
  getFeatureIsActive,
  getFeatureUrl,
  hideFeatureSection
} from "../../lookFunctions2";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import WithClickCount from "../../../hocs/withClickCount";
import LookListActiveFeatureMobileButton from "./lookListActiveFeatureMobileButton";
import LookAllWallsRadioButton from "../lookAllWallsRadioButton";
import {
  checkForCompatabilityAlert,
  clickOnSimilarFeatures,
  getApplyToLogic,
  getShowMatchRadio
} from "../../lookNavigationFunctions";
import LookFeatureItemLocked from "./lookFeatureItemLocked";
import {getAnalyticsEcommerceItem} from "../../../../../analyticsEcommerceParams";
import {getCorrectedCenter, shouldZoomPartId} from "../../../hocs/withZoomToFeature";
import LookListFeatureName from "./lookListFeatureName";
import {featureCanChangeShowerSize, searchForSameNameWallsBeforeFeatureApply} from "../../../bathroomFunctions";
import {changeToClickFeatureAccordingCurrentPosition} from "../../lookFunctions3";



const LookListFeature = (props) => {

  const {style, lookFeature, lookExpanded, lookViewType, lookActiveFeature, setLookActiveFeature, history, position,
    featureGroup, updateCanvasCount, lookActiveCategory, isMobile, isPhoneNumberValidated, canvasCount,
    addToCart, qtActiveCategory, setCanvasScale, canvasScale, navItems, updateLookCartItem,
    setLookDemoPointsClicked, lookDemoPointsClicked, viewType, fromDesignRecommended, setLookAllWallsTutorial,
    setLookCompatabilityAlert, fabricatorData, lookCompatabilityAlert, lookLockedTutorial, lookAllWallsTutorial,
    // setLookAllWallsOpened, lookAllWallsOpened,
    isAllWallsTutorialItem,
  } = props;

  const featureElement = useRef();

  const noFeatureSection = useMemo(() => {
    return hideFeatureSection(true, lookFeature.partId, lookFeature, lookCompatabilityAlert)
  }, [lookFeature, lookCompatabilityAlert]);

  const fabricatorSettings = fabricatorData.settings;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const showPriceLocked = useMemo(() => getFeatureIsLocked(lookFeature), [lookFeature, isPhoneNumberValidated]);
  const showPrice = fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost
    && !showPriceLocked && !fabricatorData.hidePricesFromUser && !noFeatureSection;
  const featureIsLocked = showPriceLocked;

  // const [canRender, setCanRender] = useState(false);
  const isEmpty = (!lookFeature && position) || (featureGroup && featureGroup.disabled);
  const currentType = viewType || lookViewType;

  // useEffect(() => {
  //   if (lookExpanded) {
  //     setTimeout(() => { // preventing thumbnail jumping
  //       setCanRender(true)
  //     }, 200)
  //   } else {
  //     setCanRender(false)
  //   }
  // }, [lookExpanded])

  const showMatchRadio = useMemo(() => getShowMatchRadio(lookFeature), [lookFeature]);

  const applyFeature = async (zoomFeature, imageCanvas, forceClick = false) => {
    zoomFeature = changeToClickFeatureAccordingCurrentPosition(zoomFeature);
    const layout = getCurrentLayout();
    const parent = zoomFeature.getParent();
    Analytics.sendEcommerceEvent("select_item", {
      item_list_id: zoomFeature.partId,
      item_list_name: parent.dbName || parent.partName || "",
      items: [getAnalyticsEcommerceItem(zoomFeature, 1)],
    });

    if (!lookActiveFeature) {
      parent.featureBeforeChange = zoomFeature;
    }
    const positionInList = navItems ? navItems.findIndex(navItem => {
      return navItem.part && (navItem.part.dbFeature.id === lookFeature.dbFeature.id)
    }) : null;
    if (!IS_PRODUCT_JOURNEY && (!isMobile || featureIsLocked)) {
      setLookActiveFeature(zoomFeature, positionInList);
    }
    if ((layout.isNewLayout || (layout.visualizerType === "bvScene")) && featureCanChangeShowerSize(zoomFeature)) {
      await searchForSameNameWallsBeforeFeatureApply(zoomFeature);
    }

    // setLookActiveCategory(zoomFeature.partId);
    if (showMatchRadio) { // before nav feature click
      const applyToLogic = getApplyToLogic(lookFeature);
      // const parent = zoomFeature.getParent();
      // setActiveFeaturesBeforeAllWalls([], parent);  // we don't need it here, as we have remembering logic below
      if (applyToLogic && Array.isArray(applyToLogic.currentApplyToArray) && applyToLogic.currentApplyToArray.length) {
        await clickOnSimilarFeatures(zoomFeature, applyToLogic, true);
        // if (!lookAllWallsOpened) {
        //   setLookAllWallsOpened(true);
        // }
      }
    }
    navFeatureCLick(zoomFeature, true, forceClick);
    enableRelatedFeature(zoomFeature, addToCart, qtActiveCategory);
    // const parent = zoomFeature.getParent();
    // if (parent.disabled) {
    //   parent.disabled = false;
    //   parent.disabledClick();
    // }
    if (updateLookCartItem) {
      updateLookCartItem(zoomFeature) // removed since we have select button on look journey
    }
    if (isMobile) {
      if (IS_PRODUCT_JOURNEY || featureIsLocked) {
        // const closeOnly = zoomFeature && !layout.partIdExistInQtCategory(zoomFeature.partId) && !showMatchRadio;
        // const closeOnly = zoomFeature && !layout.partIdExistInQtCategory(zoomFeature.partId);
        // if (closeOnly) {
        //   history.push(getFeatureUrl(zoomFeature, true))
        // } else {
        //   setLookActiveCategory("");
        //   history.push(getFeatureUrl(zoomFeature)) // always go to feature screen on mobile
        // }
        history.push(getFeatureUrl(zoomFeature, true));
      }
    } else {
      history.push(getFeatureUrl(zoomFeature, !!lookActiveCategory));
    }
    // here we can update the navigation list, but I removed it since it is sorting features and confusing customers
    // if (lookFeature.getColorName(filterGroups) !== lookActiveFeature.getColorName(filterGroups)) {
    // updateNavigationCount();
    // }
    updateCanvasCount();
    if (imageCanvas && imageCanvas.current && imageCanvas.current.pinchZoom && !LOOK_WALLS_ONLY.includes(zoomFeature.partId)
      && shouldZoomPartId(zoomFeature.partId, isMobile) && (canvasScale === 1)) {
      const commonCoords = getFeatureCoords(zoomFeature) || getCommonCoords(featureGroup || zoomFeature.getParent(), zoomFeature, imageCanvas.current.canvas);
      if (commonCoords && Object.keys(commonCoords).length) {
        const {center, scale} = getCorrectedCenter(
          getLayerCenter(commonCoords, imageCanvas.current.canvas, isMobile),
          null, zoomFeature, imageCanvas, isMobile
        );
        imageCanvas.current.pinchZoom.zoomToCenter(center, scale, false, layout.partIdExistInQtCategory(zoomFeature.partId));
        setCanvasScale(imageCanvas.current.pinchZoom.options.tapZoomFactor)
      }
    }
    if (!lookDemoPointsClicked) {
      setLookDemoPointsClicked(true);
    }
    if (!lookAllWallsTutorial.finished && showMatchRadio && !featureIsLocked && !lookFeature.notAvailableInVisualizer
      && featureElement && featureElement.current && !fabricatorData.isEncore && (currentType === 1)) {
      setLookAllWallsTutorial({
        visible: true,
        // withGrid: navItems.length === 1,
        // positionInList,
        lookFeature,
        top: featureElement.current.getBoundingClientRect().top,
        left: featureElement.current.getBoundingClientRect().left,
        height: style.height,
        // firstLockedIndex,
        // firstUnlockedIndex,
      });
    }
  }

  const listFeatureClick = (event, imageCanvas, maxClickCountReached) => {
    if (event.target.closest(".look-icon--delete") || event.target.closest(".gm-ios-checkbox") || lookLockedTutorial.visible) {
      return
    }
    if (Config.isDevMode() && lookFeature) {
      console.log("lookFeature", lookFeature, lookFeature.metaData);
    }
    if (lookExpanded) {
      document.querySelector(".lm").style.transition = "none";
      setTimeout(() => {
        document.querySelector(".lm").style.transition = "all 0.3s ease";
      }, 300)
    }
    let zoomFeature = lookFeature;
    if (isEmpty) {
      if (!lookFeature && position) {
        zoomFeature = featureGroup.getMatchingPositionFeature(position);
        if (zoomFeature) {
          featureGroup.layerPositions[position] = zoomFeature;
        }
      }
      if (zoomFeature) {
        featureGroup.activeFeature = zoomFeature;
        addToCart([getCartItemObject(zoomFeature, 1, qtActiveCategory)]);
      }
      console.log("zoomFeature featureGroup", zoomFeature, featureGroup);
    }

    if (!zoomFeature || maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    const featureLabel = Analytics.getSkuForAnalytics(zoomFeature);
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesList + featureLabel
      : fromDesignRecommended
        ? LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeaturesListDesignRecommended + featureLabel
        : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeaturesList + featureLabel;
    Analytics.sendClickEvent(analyticsLabel);

    if (featureIsLocked) {
      if (!IS_PRODUCT_JOURNEY) {
        const positionInList = navItems ? navItems.findIndex(navItem => navItem.part?.dbFeature?.id === lookFeature.dbFeature.id) : null;
        setLookActiveFeature(zoomFeature, positionInList);
        history.push(getFeatureUrl(zoomFeature, true));
      }
      return false
    }

    const compatabilityLogic = checkForCompatabilityAlert(zoomFeature);
    if (compatabilityLogic.length) {
      Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookShowCompatabilityAlert);
      setLookCompatabilityAlert({
        visible: true,
        compatabilityLogic,
        clickedFeature: zoomFeature,
        applyFunction: applyFeature.bind(this, zoomFeature, imageCanvas, true) // always apply features from this popup
      });
      return false
    }

    // if (featureIsLocked && !fabricatorSettings.clickLeadCapture && !(isIframe() && fabricatorData.isLixil)) {
    // window.clearTimeout(window.leadCaptureTimeoutId);
    // window.leadCaptureTimeoutId = setTimeout(() => {
    //   setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
    // }, 500)
    // }

    applyFeature(zoomFeature, imageCanvas);
  }

  const isActive = useMemo(() => {
    return getFeatureIsActive(lookFeature, lookActiveFeature, lookActiveCategory, featureGroup)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookFeature, lookActiveFeature, lookActiveCategory, featureGroup, canvasCount]);

  // const showYellowNotice = !IS_PRODUCT_JOURNEY && (getStyleAlertNotMatchingFeatures(lookFeature).length && !lookActiveCategory)
  //   || (lookFeature && lookRemovedCartItems.length && lookRemovedCartItems.some(cartItem => {
  //     return (cartItem.partId === lookFeature.partId) && cartItem.cartFeature.metaData.layerPosition
  //       && (cartItem.cartFeature.metaData.layerPosition === lookFeature.metaData.layerPosition)
  //   }));

  const showAllWalls = isActive && showMatchRadio && !featureIsLocked;
  const viewTypeFour = +currentType === 4;
  const isLockedAndViewTypeFour = showPriceLocked && viewTypeFour;

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <WithClickCount>
          {(maxClickCountReached) => (
            <li className={"lm-feature lm-feature--type-" + currentType
              + (lookExpanded ? " lm-feature--expanded" : "")
              + (isAllWallsTutorialItem ? " lm-feature--all-walls-tutorial" : "")
              + (featureIsLocked ? " lm-feature--locked" : " lm-feature--unlocked")
              + (isActive ? " lm-feature--active" : "")}
                style={style}
                ref={featureElement}
                onClick={(event) => listFeatureClick(event, imageCanvas, maxClickCountReached)}>
              {isEmpty ? (
                <div className="lm-feature__thumbnail lm-feature__thumbnail--empty">
                  <IconButton className="look-icon look-icon--small look-icon--white2 look-zoom__button">
                    <AddIcon/>
                  </IconButton>
                </div>
              ) : (
                <div className={"lm-feature__thumbnail" + (lookFeature.isStoneFeature ? " lm-feature__thumbnail--full" : "")}>
                  {isMobile && !IS_PRODUCT_JOURNEY
                    ? lookAllWallsTutorial.visible ? null : <LookListActiveFeatureMobileButton lookFeature={lookFeature} isActive={isActive}/>
                    : <LookListFeatureCheckmark lookFeature={lookFeature} isEmpty={isEmpty}/>}
                  <FeatureThumbnail feature={lookFeature}
                                    isMobile={isMobile}
                                    lookActiveCategory={lookActiveCategory}
                                    dbFeatureId={lookFeature.dbFeature.id}/>
                  {showAllWalls ? <LookAllWallsRadioButton lookFeature={lookFeature}
                                                           showTutorialToolTip={isAllWallsTutorialItem}
                                                           viewType={currentType}
                                                           type="small"/> : null}
                </div>
              )}
              {isEmpty ? (
                <div className="lm-feature__content lm-feature__content--empty">
                  <FormattedMessage id="look.feature.empty.addProduct"/>
                </div>
              ) : (
                <div className={"lm-feature__content" + (!showPrice && !showPriceLocked ? " lm-feature__content--no-price" : "")}>
                  {viewTypeFour || ((currentType === 2) && showPriceLocked) ? null : (
                    <span className="lm-feature__content-name">
                      <FeatureName feature={lookFeature} useCollectionName={true}/>
                      {/*{showYellowNotice ? <span className="lm-notice"/> : null}*/}
                    </span>
                  )}
                  {showPriceLocked ? <LookFeatureItemLocked type={isLockedAndViewTypeFour ? "small" : ""}/>
                    : viewTypeFour
                      ? null
                      : <LookListFeatureName lookFeature={lookFeature} />}
                  {!lookExpanded && !isLockedAndViewTypeFour ? (
                    <div className="lm-feature__content-price">
                      {!lookExpanded && !isLockedAndViewTypeFour && !noFeatureSection && !showPriceLocked ? (
                        <LookFeaturePrice showPriceAlways={true} lookFeature={lookFeature} className="lm-feature__content-price-text"/>
                      ) : null}
                      {viewTypeFour && !featureIsLocked ? <FeatureName feature={lookFeature} useCollectionName={true}/> : null}
                    </div>
                  ) : null}
                </div>
              )}
              {/*{lookFeature && lookExpanded && canRender ? (*/}
              {/*  <LookFeaturePrice lookFeature={lookFeature} className="lm-feature__price" />*/}
              {/*) : null}*/}
              {/*{lookFeature && lookExpanded && canRender ? (*/}
              {/*  <LookListFeatureActions lookFeature={lookFeature} listFeatureClick={listFeatureClick}/>*/}
              {/*) : null}*/}
            </li>
          )}
        </WithClickCount>
      )}
    </LookCanvasContext.Consumer>
  )
};

LookListFeature.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  fromDesignRecommended: PropTypes.bool,
  style: PropTypes.object,
  featureGroup: PropTypes.object,
  position: PropTypes.string,
  navItems: PropTypes.array,
  updateLookCartItem: PropTypes.func,
  viewType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isAllWallsTutorialItem: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {lookExpanded, lookViewType, lookActiveCategory, lookActiveFeature, lookDemoPointsClicked, lookCompatabilityAlert,
    //  lookAllWallsOpened
    lookLockedTutorial, lookAllWallsTutorial} = store.lookState;
  const {isMobile} = store.serverState;
  const {canvasScale, canvasCount} = store.bathroomVisualizerState;
  const {qtActiveCategory} = store.qtState;
  // const {filterGroups} = store.filterState;
  // const {lookRemovedCartItems} = store.cartState;
  const fabricatorData = store.fabricatorState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in

  return {
    lookActiveFeature,
    lookExpanded,
    lookViewType,
    lookActiveCategory,
    isMobile,
    qtActiveCategory,
    // lookRemovedCartItems,
    lookDemoPointsClicked,
    canvasScale,
    // filterGroups,
    // lookAllWallsOpened,
    fabricatorData,
    isPhoneNumberValidated,
    lookCompatabilityAlert,
    canvasCount,
    lookLockedTutorial,
    lookAllWallsTutorial,
  };
};

const mapDispatchToProps = {
  setLookActiveFeature,
  updateCanvasCount,
  setLookActiveCategory,
  addToCart,
  setCanvasScale,
  setLookDemoPointsClicked,
  setLookCompatabilityAlert,
  setLookOverlayOpened,
  setLookAllWallsTutorial,
  // updateNavigationCount,
  // setLookAllWallsOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookListFeature)
)
